
export default class IDMImpersonate {
  constructor(datasource) {
    this.datasource = datasource;
    this.impersonateAppID = null;
    this.impersonateRole = (datasource.opts.autoEnrollRole || null); //role ro be attached on registration
    this.impersonateCallbackURL = null;
    this.impersonateExtraContext = null;
    this._checkImpersonation();
  }
  allowsEnrollment() { //checks if
    return (this.isImpersonatingRole() && this.datasource.session.authorization && 
            (Array.isArray(this.impersonateRole) ?
              this.impersonateRole.find( role => !this.datasource.session.authorization.hasClaim(role)) :
              !this.datasource.session.authorization.hasClaim(this.impersonateRole)));
  }
  reloadImpersonateFromCurrentURL() {
    this._checkImpersonation();
  }

  //Indicates if the current session is impersonating another application.
  isImpersonatingApp() { return (!this.datasource.opts.disableImpersonatingApp && this.impersonateAppID && this.impersonateAppID.length > 0); }
  getApp() { return !this.datasource.opts.disableImpersonatingApp ? this.impersonateAppID : null; }
  //Indicates if the current session is impersonating another application role (for auto enrollment).
  isImpersonatingRole() { return (this.impersonateRole && this.impersonateRole.length > 0); }
  getRole() { return this.impersonateRole; }
  //Indicates if the current session is impersonating some additional context (usually used by the application logic)
  isImpersonatingExtraContext() { return (this.impersonateExtraContext && Object.keys(this.impersonateExtraContext).length > 0); }
  getImpersonatingExtraContext() { return this.impersonateExtraContext; }
  //Indicates if the current session is impersonating a callback URL
  isImpersonatingCBURL() { return (this.impersonateCallbackURL && this.impersonateCallbackURL.length > 0); }
  getCallbackURL() { return this.impersonateCallbackURL; }
  setCallbackURL(url) { this.impersonateCallbackURL = url; }
  //Unpersonate
  unpersonate() {
    this.impersonateRole = null;
    this.impersonateAppID = null;
    this.impersonateCallbackURL = null;
    this.impersonateExtraContext = null;
  }
  unpersonateRole() {
    this.impersonateRole = null;
  }

  /**
   * _checkImpersonation - Ask to impersonate the client by checking current enviroment
   * window URL for specified paramenters of IDM client. This parameters should be never
   * set or get manually, IDM client always handle all the parameters.
   * @private
   */
  _checkImpersonation() {
    if (!this.datasource.opts.disableImpersonatingApp) this.impersonateAppID = this.datasource.urlmanager.getAppID();
    this.impersonateRole = this.datasource.urlmanager.getEnrollmentRole() || this.datasource.opts.autoEnrollRole;
    this.impersonateCallbackURL = this.datasource.urlmanager.getCallbackURL();
    this.impersonateExtraContext = this.datasource.urlmanager.getExtraContext();
  }
}
